/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Export_File_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "File Export" |
*
* @param {Toolbar_Secondary_Export_File_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_export_file_aria_label = /** @type {((inputs?: Toolbar_Secondary_Export_File_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Export_File_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation de Fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateiexport")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт файла")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación de archivos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件导出")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルのエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल निर्यात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação de Arquivos")
	return /** @type {LocalizedString} */ ("File Export")
});